import React from 'react';
import './SignUpModalForm.css';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormGroup,
    Label,
    Input,
    Form,
} from 'reactstrap';
import SignUpForm from '../../forms/SignUpForm';
import { withRouter } from 'react-router-dom';

const SignUpModalForm = ({ modal, toggle, inviteCode, invitationKey, previewPostUid }) => {
    return (
        <Modal isOpen={modal} toggle={toggle} className={'sign-up-modal-form'}>
            <ModalHeader toggle={toggle}>Sign up, it's completely FREE!</ModalHeader>
            <ModalBody>
                <SignUpForm
                    previewPostUid={previewPostUid}
                    toggle={toggle}
                    inviteCode={inviteCode}
                    invitationKey={invitationKey}
                />
            </ModalBody>
        </Modal>
    );
};

export default withRouter(SignUpModalForm);
